<template>
    <PopupRouterView :showLeftIcon="true" label="Function Info Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="functioninfo"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="functionInfoInput">


        <b-card header="Function Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-function-id" label-cols-lg="12"  label="Id" label-for="input-function-id" size="sm" :model.sync="model.id"   />
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"   />
						<app-input-textbox id="fieldset-uri" label-cols-lg="12"  label="Function URL" label-for="input-uri" size="sm" :model.sync="model.uri" :isRequired="true" :state="validateState('uri')" :errorMessage="getErrorMessage(errorMessage.uri, 'uri')"   />
						<app-input-textbox id="fieldset-icon-name" label-cols-lg="12"  label="Icon Name" label-for="input-icon-name" size="sm" :model.sync="model.iconName"   />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="moduleInfos" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Module" id="fieldset-module-info" size="sm" :model.sync="model.moduleInfoId"   :selected="model.moduleInfo != null ? model.moduleInfo.name : ''" @input="getModuleInfos"   :isSelectMethodExists="true" @onSelectMethod="setSelectedModuleInfo" />
						<app-input-checkbox id="fieldset-is-is-approval" label-cols-lg="12" label="Is Approval Mode" label-for="input-is-is-approval" size="sm" :model.sync="model.isApproval" checkedValue="Yes" uncheckedValue="No"  />
						<app-input-checkbox id="fieldset-is-is-enabled" label-cols-lg="12" label="Is Enabled" label-for="input-is-is-enabled" size="sm" :model.sync="model.isEnabled" checkedValue="Yes" uncheckedValue="No"  />
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FunctionInfo from '@/models/FunctionInfo/FunctionInfo';
import FunctionInfoList from '@/models/FunctionInfo/FunctionInfoList';
import FunctionInfoFilter from '@/filters/FunctionInfo/FunctionInfoFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ModuleInfo from '@/models/ModuleInfo/ModuleInfo';
import ModuleInfoFilter from '@/filters/ModuleInfo/ModuleInfoFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputCheckbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
			uri: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Name is Required."},
				uri: { required : "Function URL is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterFunctionInfo : null,
			currentFunctionInfoPage : 1,
			functionInfoPageSize: 10,
			sortByFunctionInfo: '',
			sortDescFunctionInfo: '',
			moduleInfos: [],
			moduleInfos: [],
			isModuleInfoComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isModuleInfoComboLoading: false,
		}
	},
	methods : {
		getFunctionInfo : async function(id) {
			this.isBusy = true;
			FunctionInfo.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadFunctionInfo = true;
			this.filterFunctionInfo.id = this.modelId;
			FunctionInfo.downloadDataDetail(this, this.filterFunctionInfo).then(result => {
				this.isDownloadFunctionInfo = false;
			}).catch(error => { this.isDownloadFunctionInfo = false; })
		},
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isFunctionInfoComboLoading = true;
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
				this.isFunctionInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getModuleInfos : async function(input) {
			let filter = new ModuleInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ModuleInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.moduleInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedModuleInfo(item) {
			if(item == undefined || item == null) {
				this.model.moduleInfoId = null;
				this.model.moduleInfo = null;
			} else {
				this.model.moduleInfoId = item.id;
				this.model.moduleInfo = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.functionInfoInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						FunctionInfo.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'functioninfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						FunctionInfo.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'functioninfoindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FunctionInfo.updateData(this, model, id)
					.catch((error) => {
						this.getFunctionInfo(id);
					});
				}
			});
		},
		onHidden() {
			this.getFunctionInfos();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterFunctionInfo = new FunctionInfoFilter();
		//this.getModuleInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getFunctionInfo(id);
			} else {
				this.modelId = id;
				this.getFunctionInfo(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
